import { render } from "./signupProcess.vue?vue&type=template&id=5ccb6727&scoped=true"
import script from "./signupProcess.vue?vue&type=script&lang=js"
export * from "./signupProcess.vue?vue&type=script&lang=js"

import "./signupProcess.vue?vue&type=style&index=0&id=5ccb6727&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ccb6727"]])

export default __exports__